import React from 'react';


export const FancyButtonNavBar = (props) => {
    const { text, shadow = true, onClick, activeLink } = props;

    const className = props.className ? `button ${props.className}` : "button";

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}
        className={`container ${shadow ? 'shadow' : ''}`}
      >
        <div
          onClick={onClick}
          style={{ marginLeft: '3em', padding: '6px', width: '100%', cursor: 'pointer' }}
        >
          <a className={className} style={{ color: `${activeLink ? 'white' : '#C9C9C9'}`, fontSize: '20px', fontWeight: 'bold', alignSelf: 'center' }} >
            {text}
          </a>
        </div>
      </div>)
  }